import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { axiosApi } from "./axiosApi";
import { getLanguageFromPath } from "./simpleUtils";

let AuthContext = createContext(null);

const useAuth = () => {
    return useContext(AuthContext);
}

const AuthProvider = ({ children }) => {
    let [authState, setAuthState] = useState({
        checked: false,
        loggedIn: false,
        loggedOutLang: null
    });

    const location = useLocation();

    let checkLogin = () => {

        const language = getLanguageFromPath(location.pathname);
        axiosApi.get(
            '/check-login'
        ).then(res => {
            setAuthState({
                checked: true,
                loggedIn: true,
                loggedOutLang: language,
            });
        }).catch(error => {
            setAuthState({
                checked: true,
                loggedIn: false,
                loggedOutLang: language,
            });
        })
    }

    let login = (loginData) => {
        return axiosApi.post(
            '/login', loginData
        ).then(()=> {
            setAuthState({
                checked: true,
                loggedIn: true,
                loggedOutLang: null,
            });
        });
    };

    let logout = () => {
        const loggedOutLang = getLanguageFromPath(location.pathname);

        return axiosApi.post(
            '/logout'
        ).then(()=> {
            setAuthState({
                checked: true,
                loggedIn: false,
                loggedOutLang,
            });
        });
    };

    let value = {
        state: authState,
        setState: setAuthState,
        checkLogin,
        login,
        logout,
    };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

const RequireAuth = ({ children }) => {
    let auth = useAuth();

    useEffect(() => {
        auth.checkLogin();
    }, []);

    if (!auth.state.checked) {
        return <></>
    } else if (!auth.state.loggedIn) {
        window.location.href = '/n/login';
        return <></>
    } else {
        return children;
    }
}

export {
    useAuth,
    AuthProvider,
    RequireAuth,
}